import React, { memo, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { getUiChromeState } from '@components/MainStage/uiChrome.store';
import useProjectId from '@hooks/useProjectId';
import { Stack } from '@mui/material';
import Toolbox from '@views/Project/components/Toolbox/Toolbox';
import useSetupInitialMode from '@views/Project/hooks/useSetupInitialMode';
import useProjectRedirect from '@views/ProjectHome/useProjectRedirect';

const CANVAS_ROUTE_PATTERN = /\/(model|insights)\/?$/;

export const ProjectHome = memo(() => {
  const projectId = useProjectId();
  const { pathname } = useLocation();

  useSetupInitialMode();
  useProjectRedirect();

  useEffect(() => {
    getUiChromeState().reset();
  }, [projectId]);

  useEffect(() => {
    if (CANVAS_ROUTE_PATTERN.test(pathname)) return;

    getUiChromeState().reset();
  }, [pathname]);

  useEffect(() => () => getUiChromeState().reset(), []);

  return (
    <Stack sx={{ height: '100%', position: 'relative' }}>
      <Toolbox />
      <Outlet />
    </Stack>
  );
});
